module.exports = __webpack_public_path__ + "media/images/classpoints/brands/SL-4e1f92ef876dbb05a6414a528f6577a1.svg";